import React from 'react';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import { UiInputAdapter, UiFieldset } from 'src/ui';
import { cleanseInt, cleanseDecimal } from 'src/ui/util';
import propTypes from 'prop-types';

export function EquipmentForm({ form }) {
  return (
    <>
      <UiFieldset title="Terminal Model 1">
        <Columns isMultiline>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="terminalModel1"
              id="terminalModel1"
              label="Terminal Model"
            />
            <Field
              component={UiInputAdapter}
              name="terminalQuantity1"
              id="terminalQuantity1"
              label="Quantity"
              onChange={e => form.mutators.cleanse(e, cleanseInt)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="terminalVersion1"
              id="terminalVersion1"
              label="Terminal Version"
            />
            <Field
              component={UiInputAdapter}
              name="terminalPrice1"
              id="terminalPrice1"
              label="Terminal Price $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
            />
          </Column>
        </Columns>
      </UiFieldset>
      <UiFieldset title="Terminal Model 2">
        <Columns isMultiline>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="terminalModel2"
              id="terminalModel2"
              label="Terminal Model"
            />
            <Field
              component={UiInputAdapter}
              name="terminalQuantity2"
              id="terminalQuantity2"
              label="Quantity"
              onChange={e => form.mutators.cleanse(e, cleanseInt)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="terminalVersion2"
              id="terminalVersion2"
              label="Terminal Version"
            />
            <Field
              component={UiInputAdapter}
              name="terminalPrice2"
              id="terminalPrice2"
              label="Terminal Price $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
            />
          </Column>
        </Columns>
      </UiFieldset>
      <UiFieldset title="Terminal Model 3">
        <Columns isMultiline>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="terminalModel3"
              id="terminalModel3"
              label="Terminal Model"
            />
            <Field
              component={UiInputAdapter}
              name="terminalQuantity3"
              id="terminalQuantity3"
              label="Quantity"
              onChange={e => form.mutators.cleanse(e, cleanseInt)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="terminalVersion3"
              id="terminalVersion3"
              label="Terminal Version"
            />
            <Field
              component={UiInputAdapter}
              name="terminalPrice3"
              id="terminalPrice3"
              label="Terminal Price $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
            />
          </Column>
        </Columns>
      </UiFieldset>
    </>
  );
}

EquipmentForm.propTypes = {
  form: propTypes.object.isRequired,
};
